import type { Player } from '../types';
import { useState } from 'react';

export function PlayerAvatar({ player, size = 'md' }: { player: Player; size?: 'sm' | 'md' | 'lg' }) {
  const [imageFailed, setImageFailed] = useState(false);
  const initials = player.name.split(/\s+/).slice(0, 2).map((part) => part[0]).join('').toUpperCase();
  return (
    <span className={`player-avatar player-avatar--${size} element-bg--${player.element.toLowerCase()} ${player.image_url && !imageFailed ? 'has-photo' : ''}`} aria-hidden="true">
      {player.image_url && !imageFailed
        ? <img src={player.image_url} alt="" loading="lazy" referrerPolicy="no-referrer" onError={() => setImageFailed(true)} />
        : <span>{initials}</span>}
    </span>
  );
}
